// extracted by mini-css-extract-plugin
export default {"root":"Hero_root__3i1wH","text":"Hero_text__16HYv","title":"Hero_title__1gDuO","copy":"Hero_copy__zE1iP","image":"Hero_image__eDW1c"};